// src/icons/HeartOutline.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function HeartOutline({
  strokeWidth = "1.5",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "100%",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.1041 2.9055C12.6568 1.46965 10.3103 1.46965 8.86307 2.9055L7.98955 3.88576L7.11603 2.90552C5.66876 1.46967 3.32227 1.46967 1.875 2.90552C0.427734 4.34137 0.427732 6.66934 1.875 8.10519L7.98953 14.1715L14.1041 8.10517C15.5514 6.66932 15.5514 4.34135 14.1041 2.9055Z",
          stroke: "currentColor",
          strokeWidth,
          strokeLinejoin
        }
      )
    }
  );
}

export {
  HeartOutline
};
